<div class="grid-actions-panel" data-e2e-id="xux-table-actions">
  <xvi-action-button
    *ngFor="let button of buttons"
    [button]="button"
    (buttonClick)="actionButtonClick($event)"
    [style.order]="button.flexOrder"
  ></xvi-action-button>

  <div
    *ngIf="showSearch"
    class="xux-input search-input-row input-row input-row-with-icon"
    [style.order]="buttonFlexOrder.SEARCH"
  >
    <input
      #quickFilterInput
      [formControl]="quickFilterControl"
      [value]="quickFilterControlValue$ | async"
      (keyup.enter)="quickFilterChanged()"
      type="text"
      [placeholder]="searchPlaceholder"
      [attr.customScanning]="true"
    />

    <xux-icon *ngIf="!(quickFilterControlValue$ | async)" icon="icon-search"></xux-icon>
    <xux-icon
      *ngIf="quickFilterControlValue$ | async"
      (click)="quickFilterControl.reset(''); quickFilterChanged()"
      icon="icon-close"
      class="cursor-pointer"
    ></xux-icon>
  </div>

  <div class="panel-separator" [style.order]="buttonFlexOrder.CENTER"></div>

  <ng-content></ng-content>
</div>
